/**
 * @generated SignedSource<<98a3ad909b8ef3cf6edc3c03fbb77570>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RefundStatus = "ApplyComplete" | "ApplyImpossible" | "ApplyPossible" | "Complete" | "Impossible" | "None" | "Possible" | "RefundFinish" | "RefundImpossible" | "Retry";
export type lookupUserQuery$variables = Record<PropertyKey, never>;
export type lookupUserQuery$data = {
  readonly bznavRefund: {
    readonly user: {
      readonly corps: ReadonlyArray<{
        readonly businessInfo: {
          readonly hometaxBizName: string | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly partnerInfo: {
          readonly discountRate: string;
        } | null | undefined;
        readonly refundAmount: string;
        readonly refundId: string;
      }> | null | undefined;
      readonly indis: ReadonlyArray<{
        readonly businessInfo: {
          readonly taxpayerName: string | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly partnerInfo: {
          readonly discountRate: string;
        } | null | undefined;
        readonly refundAmount: string;
        readonly refundId: string;
      }> | null | undefined;
      readonly previousIndis: ReadonlyArray<{
        readonly id: string;
      }> | null | undefined;
      readonly tritxIndis: ReadonlyArray<{
        readonly businessInfo: {
          readonly taxpayerName: string | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly partnerInfo: {
          readonly discountRate: string;
        } | null | undefined;
        readonly refundAmount: string;
        readonly refundStatus: RefundStatus;
        readonly tritxReSearchRequestId: number | null | undefined;
      }> | null | undefined;
    };
  };
};
export type lookupUserQuery = {
  response: lookupUserQuery$data;
  variables: lookupUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundAmount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "BusinessInfo",
  "kind": "LinkedField",
  "name": "businessInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxpayerName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "RefundPartnerType",
  "kind": "LinkedField",
  "name": "partnerInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "discountRate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BznavRefundOutput",
    "kind": "LinkedField",
    "name": "bznavRefund",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RefundUserType",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundHistoryType",
            "kind": "LinkedField",
            "name": "indis",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundHistoryType",
            "kind": "LinkedField",
            "name": "previousIndis",
            "plural": true,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundHistoryType",
            "kind": "LinkedField",
            "name": "tritxIndis",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "refundStatus",
                "storageKey": null
              },
              (v0/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tritxReSearchRequestId",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundHistoryType",
            "kind": "LinkedField",
            "name": "corps",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BusinessInfo",
                "kind": "LinkedField",
                "name": "businessInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hometaxBizName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "lookupUserQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "lookupUserQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "ba735955a9c06df379172ee071c8b95b",
    "id": null,
    "metadata": {},
    "name": "lookupUserQuery",
    "operationKind": "query",
    "text": "query lookupUserQuery {\n  bznavRefund {\n    user {\n      indis {\n        id\n        refundId\n        refundAmount\n        businessInfo {\n          taxpayerName\n        }\n        partnerInfo {\n          discountRate\n        }\n      }\n      previousIndis {\n        id\n      }\n      tritxIndis {\n        refundStatus\n        id\n        refundAmount\n        tritxReSearchRequestId\n        businessInfo {\n          taxpayerName\n        }\n        partnerInfo {\n          discountRate\n        }\n      }\n      corps {\n        id\n        refundId\n        refundAmount\n        businessInfo {\n          hometaxBizName\n        }\n        partnerInfo {\n          discountRate\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0196199ed4944ba9ec8583e51e8013e5";

export default node;
